import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafeHtmlModule } from '@shared/pipes';
import { AlertComponent } from './alert.component';

@NgModule({
  declarations: [AlertComponent],
  imports: [CommonModule, SafeHtmlModule],
  exports: [AlertComponent],
})
export class AlertModule {}
